<template>
  <div />
</template>

<script>

/**
 * Vue: Duo banner (duo-banner)
 * -----------------------------------------------------------------------------
 * Duo banner section.
 * - Limited interactivity section, triggers 'Shop the Look' modal.
 *
 * @param {String} sectionId - Section ID.
 * @param {Object} blocks - Object with blocks settings.
 *
 */
export default {
  name: 'DuoBanner',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
    blocks: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: 'shop-the-look',

  mounted() {
    this.handleShopTheLook()
  },

  methods: {

    /**
     * Check for Shop the Look eligibility, set event listeners if eligible.
     */
    handleShopTheLook() {
      if (!this.blocks.length) {
        return
      }

      this.blocks.forEach((block) => {
        const { id, enableShopTheLook, shopTheLookCollection } = block

        if (!enableShopTheLook || shopTheLookCollection === null) {
          return
        }

        const button = document.querySelector(
          `[data-id="${this.sectionId}"] [data-id="${id}"] [data-shop-the-look]`,
        )

        if (!button) {
          return
        }

        button.addEventListener('click', (event) => {
          event.preventDefault()

          window.cnvs.EventBus.emit('shop-the-look', {
            collection: shopTheLookCollection,
          })
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import './duo-banner';
</style>
